/* okbye-i18n (v64) — version anglaise du site
   Chargé seulement quand la langue n'est pas le français (voir layout/theme.liquid).
   1. Les appels au panier / produits restent dans la langue choisie (/en/cart.js, /en/?sections=…)
   2. Les liens internes gardent le /en
   3. Les textes créés par nos scripts (panier, quiz, stories…) sont traduits */
(function () {
  var ROOT = window.OKBYE_ROOT || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (ROOT === '/') return;
  var PREFIX = ROOT.replace(/\/$/, ''); // ex. "/en"
  var LOCAL = /^\/(cart|products|collections|recommendations|search|pages|blogs|account|contact|\?)/;

  function localize(url) {
    if (typeof url !== 'string' || url.charAt(0) !== '/' || url.charAt(1) === '/') return url;
    if (url === PREFIX || url.indexOf(PREFIX + '/') === 0 || url.indexOf(PREFIX + '?') === 0) return url;
    if (url === '/') return ROOT;
    return LOCAL.test(url) ? PREFIX + url : url;
  }
  window.okbyeUrl = localize;

  // 1. fetch / XHR
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      if (typeof input === 'string') input = localize(input);
      return _fetch.call(this, input, init);
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    var args = Array.prototype.slice.call(arguments);
    args[1] = localize(url);
    return _open.apply(this, args);
  };

  // 3. Textes
  var EXACT = {
    'Ajouter': 'Add', '+ Ajouter': '+ Add', 'Ajouter –': 'Add –', 'Ajouté!': 'Added!', 'Ajouté ✓': 'Added ✓', 'Ajouté': 'Added',
    'Ajouter au panier': 'Add to cart', 'Épuisé': 'Sold out', 'Fermer': 'Close', 'Précédent': 'Previous', 'Suivant': 'Next', '← Précédent': '← Previous', 'Choisir': 'Choose', 'Appliquer': 'Apply', 'Format': 'Size', 'Tu as un code promo?': 'Have a promo code?',
    'Voir le produit': 'View product', 'Voir tout': 'See all', 'En savoir plus': 'Learn more', 'dès': 'from',
    'Cadeau inclus — ajouté à chaque commande': 'Free gift included with every order',
    'Ajouté automatiquement avec chaque commande': 'Added automatically to every order',
    'Complète ton ambiance Ok Bye': 'Complete your Ok Bye vibe',
    'Bougie du mois': 'Candle of the month',
    'Livraison gratuite débloquée': 'Free shipping unlocked', 'Livraison GRATUITE': 'FREE shipping',
    'Ajoute ': 'Add ', 'Plus que ': 'Only ', ' pour la ': ' away from ', ' pour la livraison gratuite': ' more for free shipping',
    'livraison gratuite': 'free shipping', 'Il te manque ': "You're ", ' pour débloquer ': ' away from unlocking ',
    'fermer les détails': 'hide details', 'plus de détails': 'more details',
    'CHOISIS TON CADEAU GRATUIT — ON TE GÂTE <3': 'PICK YOUR FREE GIFT — WE SPOIL YOU <3',
    'Avec ta commande': 'With your order', 'Cadeau gratuit avec ta commande': 'Free gift with your order',
    'Tous tes avantages sont débloqués!': 'All your perks are unlocked!', '— Crée ton ambiance idéale': '— Create your perfect vibe',
    'Code appliqué !': 'Code applied!', "Ce code n'est pas valide pour ton panier.": "This code isn't valid for your cart.",
    'Entre un code promo.': 'Enter a discount code.', 'Code retiré.': 'Code removed.',
    'Oups, une erreur est survenue. Réessaie.': 'Oops, something went wrong. Try again.', 'Oups, réessaie.': 'Oops, try again.',
    'Vidéos Ok Bye': 'Ok Bye videos', 'Vidéo précédente': 'Previous video', 'Vidéo suivante': 'Next video',
    'Glisse vers le haut pour la suivante': 'Swipe up for the next one',
    'Offre valide pour une durée limitée selon les stocks': 'Limited-time offer, while supplies last',
    // Quiz
    'Tu allumes une bougie pour…': 'You light a candle to…', 'Te détendre': 'Unwind', 'Séduire': 'Seduce', 'T’énergiser': 'Get energized',
    'Célébrer': 'Celebrate', 'Te concentrer': 'Focus', 'Tu préfères les odeurs…': 'Your favourite scents are…',
    'Fraîches': 'Fresh', 'Florales': 'Floral', 'Gourmandes': 'Gourmand', 'Fruitées': 'Fruity', 'Boisées': 'Woody', 'Sensuelles': 'Sensual',
    'Ton ambiance préférée c’est…': 'Your favourite vibe is…', 'Chalet en hiver': 'A cabin in winter', 'Terrasse en été': 'A patio in summer',
    'Pluie d’automne': 'Fall rain', 'Fleurs de printemps': 'Spring flowers',
    'Ton entourage te décrirait comme la personne…': 'Your friends would describe you as the…',
    'Créative': 'Creative one', 'Romantique': 'Romantic', 'Boss': 'Boss', 'Fan de plein air': 'Outdoorsy one', 'Party animal': 'Party animal',
    'Choisis une ou plusieurs réponses': 'Pick one or more answers', '← Retour': '← Back', 'Voir mes bougies': 'See my candles', 'Suivant →': 'Next →',
    'Presque là !': 'Almost there!', 'Où envoyer tes résultats ?': 'Where should we send your results?',
    'Entre ton courriel pour découvrir tes bougies idéales.': 'Enter your email to discover your perfect candles.',
    'On ne spam jamais. Promis.': 'We never spam. Promise.', 'Voir mes résultats →': 'See my results →', 'Résultats': 'Results',
    'Tes bougies faites pour toi': 'Candles made for you', 'On a trouvé ton match olfactif parfait !': 'We found your perfect scent match!',
    'Coup de cœur': 'Top pick', '← Recommencer le quiz': '← Retake the quiz', 'ton@courriel.com': 'you@email.com',
    // Noms de bougies dans le quiz
    'Mangue & Fruit de la passion': 'Mango & Passion Fruit', 'Lime & Noix de coco': 'Lime & Coconut',
    'Fraise des bois & Basilic': 'Wild Strawberry & Basil', 'Pistache & Caramel salé': 'Pistachio & Salted Caramel',
    'Figues & Sucre brun': 'Figs & Brown Sugar', 'Rose & Vanille': 'Rose & Vanilla', 'Suède & Pomme de pin': 'Suede & Pine Cone',
    'Pacanes Grillées': 'Toasted Pecans', 'Gâteau de fête': 'Birthday Cake', 'Mahogany Teakwood Épicé': 'Spiced Mahogany Teakwood',
    'Forêt & Pluie': 'Forest & Rain', 'Odeur Signature': 'Signature Scent', 'Pêches & Crème': 'Peaches & Cream',
    'Cèdre & Cachemire': 'Cedar & Cashmere', 'Piña Colada x Choco Favoris': 'Piña Colada x Chocolats Favoris'
  };
  var PATTERNS = [
    [/^Question (\d+) sur (\d+)$/, 'Question $1 of $2'],
    [/^Ajouter – (.+)$/, 'Add – $1'],
    [/^Choisir – (.+)$/, 'Choose – $1'],
    [/^Plus que (.+) pour ton cadeau$/, 'Only $1 away from your free gift'],
    [/^Cadeau offert dès (.+)$/, 'Free gift on orders over $1'],
    [/^Ajoute (\d+) bougies? 9 oz de plus pour économiser (\d+) ?%$/, 'Add $1 more 9 oz candle(s) to save $2%'],
    [/^Tu économises (\d+) ?% sur tes bougies 9 oz(.*)$/, "You're saving $1% on your 9 oz candles$2"],
    [/^Dépense encore (.+) pour débloquer ton t-shirt gratuit!$/, 'Spend $1 more to unlock your free t-shirt!'],
    [/^Ton t-shirt gratuit est débloqué — ajoute-le à ta commande!$/, 'Your free t-shirt is unlocked — add it to your order!'],
    [/^Gagne (\d+) flammes avec cet achat$/, 'Earn $1 flames with this purchase'],
    [/^Cette commande te rapporte (\d+) flammes$/, 'This order earns you $1 flames'],
    [/^(\d+) flammes$/, '$1 flames'],
    [/^Plus que (\d+) en stock ?!$/, 'Only $1 left!']
  ];

  function tr(s) {
    if (!s) return null;
    var m = s.match(/^(\s*)([\s\S]*?)(\s*)$/);
    var core = m[2].replace(/ /g, ' ');
    if (!core) return null;
    var out = EXACT.hasOwnProperty(core) ? EXACT[core] : null;
    if (out === null && EXACT.hasOwnProperty(s.replace(/ /g, ' '))) return EXACT[s.replace(/ /g, ' ')];
    if (out === null) {
      for (var i = 0; i < PATTERNS.length; i++) {
        if (PATTERNS[i][0].test(core)) { out = core.replace(PATTERNS[i][0], PATTERNS[i][1]); break; }
      }
    }
    return out === null ? null : m[1] + out + m[3];
  }
  window.okbyeT = function (s) { return tr(s) || s; };

  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt'];
  function fixEl(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute && el.getAttribute(ATTRS[i]);
      if (v) { var t = tr(v); if (t !== null && t !== v) el.setAttribute(ATTRS[i], t); }
    }
    if (el.tagName === 'A') {
      var h = el.getAttribute('href');
      var lh = localize(h);
      if (h && lh !== h) el.setAttribute('href', lh);
    }
  }
  function walk(node) {
    if (node.nodeType === 3) {
      var p = node.parentNode;
      if (p && (p.tagName === 'SCRIPT' || p.tagName === 'STYLE')) return;
      var t = tr(node.nodeValue);
      if (t !== null && t !== node.nodeValue) node.nodeValue = t;
      return;
    }
    if (node.nodeType !== 1 || node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
    fixEl(node);
    for (var c = node.firstChild; c; c = c.nextSibling) walk(c);
  }
  function start() {
    walk(document.body);
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (r.type === 'characterData') walk(r.target);
        else if (r.type === 'attributes') fixEl(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'].concat(ATTRS) });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
